import { hot } from 'react-hot-loader/root';
import { QueryClient, QueryClientProvider } from '@zg-rentals/react-query5';
import { getRoutes, manifest } from '../app/routes';
import { AppContainer, useRentalManagerUser, useRouter } from '@zg-rentals/rental-manager-env';
import { useSiftScience } from '@zg-rentals/sift-science';
import { BillingPortalStateProvider } from '../providers/BillingPortalStateProvider';
import React from 'react';
import { GuestPayProgressHeader } from '../pages/GuestPay/GuestPayProgressHeader';
import { useComscorePageTracking } from '@zg-rentals/comscore';
import { trackComscoreEvent, trackUserEvent } from '../analytics';
import { useZrmPageViewEvents } from '@zg-rentals/clickstream';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const { user } = useRentalManagerUser();
  const router = useRouter();

  useComscorePageTracking(() => trackComscoreEvent({}), router.pathname);
  useSiftScience({ email: user?.email, isImpersonator: Boolean(user?.impersonatorUserToken) });
  useZrmPageViewEvents(trackUserEvent, location.pathname, user);

  const customHeader = React.useMemo(() => {
    if (router.pathname === manifest.guestPayInvoicesPage) {
      return <GuestPayProgressHeader activeStepIndex={0} />;
    } else if (router.pathname === manifest.guestPayPaymentDetailsPage) {
      return <GuestPayProgressHeader activeStepIndex={1} />;
    } else if (router.pathname === manifest.guestPaySubmitPaymentPage) {
      return <GuestPayProgressHeader activeStepIndex={2} />;
    }
  }, [router.pathname]);

  React.useLayoutEffect(() => {
    document.body.setAttribute('data-panda-theme', 'zillow');

    return () => {
      document.body.removeAttribute('data-panda-theme');
    };
  }, []);

  return (
    <BillingPortalStateProvider userIsGuest={!user.loggedIn}>
      <QueryClientProvider client={queryClient}>
        <AppContainer customerHeader={customHeader}>{getRoutes()}</AppContainer>
      </QueryClientProvider>
    </BillingPortalStateProvider>
  );
};

export default hot(App);
